import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from "rxjs";
import {IBusinessUnit} from "../../../business-units/models";
import {MatTableDataSource} from "@angular/material/table";
import {
  toggleLoading,
  updateBusinessUnits, updateSelectedBusinessUnit
} from "../../../redux";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort, Sort} from "@angular/material/sort";
import {BusinessUnitService} from "../../../business-units/services";
import {ToastrService} from "ngx-toastr";
import {Store} from "@ngrx/store";
import {MatDialog} from "@angular/material/dialog";
import {
  ConfirmationModalComponent,
  DeleteConfirmationModalComponent, UserCardModalComponent, UserCardSize
} from "../../../shared/components";
import {UtilService} from "../../../shared/services";
import {ModalSize} from "../../../shared/services/util/util.service";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {ICompanyEmployeeResponse} from "../../models";
import { AddNewEmployeeComponent } from 'src/app/dialogs/add-new-employee/add-new-employee.component';
import { DataService } from 'src/app/services/data/data.service';



@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss'],
  // animations: [
  //   trigger('detailExpand', [
  //     state('collapsed', style({height: '0px', minHeight: '0'})),
  //     state('expanded', style({height: '*'})),
  //     transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  //   ]),
  // ],
})
export class CompanyListComponent implements OnInit, OnDestroy {


  businessUnit?: IBusinessUnit;
  dataSource: MatTableDataSource<ICompanyEmployeeResponse> = new MatTableDataSource();
  employees: ICompanyEmployeeResponse[] = [];
  sortedEmployees: ICompanyEmployeeResponse[] = [];

  columnsToDisplay = ['employee', 'title', 'role', 'invite', 'active', 'created', 'edit'];
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  userCardSize = UserCardSize;

  constructor(private businessUnitService: BusinessUnitService,
              private toastr: ToastrService,
              private activatedRoute: ActivatedRoute,
              private store: Store,
              private dialog: MatDialog,
              public util: UtilService,
              private dataService: DataService,
              private router: Router
  ) {


  }

  ngOnInit() {
    var action = this.activatedRoute.snapshot.queryParamMap.get("action");
    if (action === "add-employee") {
      // there is an action
      this.addEmployee();
    }

    // load the employees for the table
    this.getEmployees();

    // set the current business unit for the user card at the top
    this.businessUnit = this.dataService.currentBusinessUnit;
  }

  ngOnDestroy() {
  }

  getEmployees() {
    this.store.dispatch(toggleLoading({loading: true}));
    this.businessUnitService.getBusinessUnitEmployees(this.dataService.getBuId()).subscribe({
      next: (employees: ICompanyEmployeeResponse[]) => {
        this.dataSource = new MatTableDataSource(employees);
        this.store.dispatch(toggleLoading({loading: false}));
        this.employees = employees;
      }, error: (err: HttpErrorResponse) => {
        this.store.dispatch(toggleLoading({loading: false}));
        // this.toastr.error("Something went wrong!");
      }
    });
  }

  initDataSource() {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const concatName = data.user.firstName + " " + data.user.lastName + " " + data.user.email;
      const NM = concatName.toLowerCase().includes(filter.toLowerCase());
      return NM;
    };
    if (!!this.paginator) {
      this.paginator.pageSize = 10;
      this.dataSource.paginator = this.paginator;
    }
    if (!!this.sort) {
      this.dataSource.sort = this.sort;
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  delete(employee: ICompanyEmployeeResponse) {
    this.dialog.open(DeleteConfirmationModalComponent, {
      height: 'auto',
      width: 'auto',
      data: employee
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        this.store.dispatch(toggleLoading({loading: true}));
        this.businessUnitService.deleteBusinessUnitEmployee(employee.id).subscribe({
          next: res => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastr.success("Employee Removed!", $localize`:@@companyName:Rondeivu`);
            this.getEmployees();
          }, error: err => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastr.error("Something went wrong!");
          }
        });
      }
    });
  }

  viewInfo(employee: any) {
    this.store.dispatch(toggleLoading({loading: true}));
    this.router.navigate(['/', this.dataService.getBuSlug(), 'my-company', employee.id, 'information']).then(() => {
      this.store.dispatch(toggleLoading({loading: false}));
    });
  }

  viewPermissions(employee: any) {
    this.store.dispatch(toggleLoading({loading: true}));
    this.router.navigate(['/', this.dataService.getBuSlug(), 'my-company', employee.id, 'permissions']).then(() => {
      this.store.dispatch(toggleLoading({loading: false}));
    });
  }

  addEmployee() {
    this.dialog.open(AddNewEmployeeComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.SMALL),
      disableClose: true
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        // console.log("Dialog closed with payload!");
        this.store.dispatch(toggleLoading({loading: true}));
        this.businessUnitService.addBusinessUnitEmployee(result).subscribe({
          next: (res: any) => {
            // this.employees.push(res);
            // this.dataSource = new MatTableDataSource(this.employees);
            // this.initDataSource();
            this.getEmployees();
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastr.success("Employee Added!", $localize`:@@companyName:Rondeivu`);
          }, error: error => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastr.error("Something went wrong!");
          }
        });
      }
    });
  }

  openImageUploadModal() {
    this.dialog.open(UserCardModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.SMALL),
      disableClose: true
    })
    .afterClosed().subscribe(result => {
      console.log("Dialog closed!");
      if (!!result) {
        const id = this.dataService.getBuId();
        const file = new File([result], 'user.png');
        this.businessUnitService.uploadBusinessUnitImageForEmployee(file, id).subscribe({
          next: (res: any) => {
            this.updateSelectedBusinessUnitImageUrl(res.url);
            this.toastr.success("Image Uploaded! ", $localize`:@@companyName:Rondeivu`);
          }, error: (err: any) => {
            this.toastr.error("Something went wrong! " + err.message);
          }
        });
      }
    });
  }

  private updateSelectedBusinessUnitImageUrl(url: string) {
    console.log("Updating business unit image url to: " + url);
    if (this.businessUnit) {
      this.businessUnit = {...this.businessUnit, imageUrl: url};
      this.store.dispatch(updateSelectedBusinessUnit({businessUnit: this.businessUnit}));
    }
  }

  clearImage() {
    this.dialog.open(ConfirmationModalComponent, {
      height: 'auto',
      width: 'auto',
      disableClose: true,
      data: {}
    })
    .afterClosed().subscribe(result => {
      console.log("Dialog closed!");
      if (!!result) {
        const id = this.dataService.getBuId();
        this.businessUnitService.clearBusinessUnitImageForEmployee(id).subscribe({
          next: (res: any) => {
            this.updateSelectedBusinessUnitImageUrl(res.url);
            this.toastr.success("Image Cleared! ", $localize`:@@companyName:Rondeivu`);
          }, error: (err: any) => {
            this.toastr.error("Something went wrong! " + err.message);
          }
        });
      }
    });
  }

  //sort
  sortData(sort: Sort) {
    const data = this.employees.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedEmployees = data;
      return;
    }

    this.sortedEmployees = data.sort((a: ICompanyEmployeeResponse, b: ICompanyEmployeeResponse) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'employee':
          const n1 = a.user.firstName + ' ' + a.user.lastName;
          const n2 = b.user.firstName + ' ' + b.user.lastName;
          return compare(n1, n2, isAsc);
        case 'title':
          return compare(a.title, b.title, isAsc);
        case 'active':
          return compare(a.isEmployeeActive.toString(), b.isEmployeeActive.toString(), isAsc);
        case 'role':
          return compare(a.role, b.role, isAsc);
        case 'status':
          return compare(a.memberInviteStatus, b.memberInviteStatus, isAsc);
        default:
          return 0;
      }
    });

    this.dataSource = new MatTableDataSource(this.sortedEmployees);
    this.initDataSource();
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
